import React from "react";
import ReactDOM from "react-dom";

import App from "./app/App";
import { BrowserRouter } from "react-router-dom";
import thunk from "redux-thunk";
import reducers from "./store/combinedReducers";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";

import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "material-icons/iconfont/material-icons.css";

import "./app/Welcome.css";
import "./index.css";
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

//serviceWorkerRegistration.register();
